import { render, staticRenderFns } from "./orderIndex.vue?vue&type=template&id=4018cee4&scoped=true&"
import script from "./orderIndex.vue?vue&type=script&lang=js&"
export * from "./orderIndex.vue?vue&type=script&lang=js&"
import style0 from "./orderIndex.vue?vue&type=style&index=0&id=4018cee4&lang=less&scoped=true&"
import style1 from "./orderIndex.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4018cee4",
  null
  
)

export default component.exports